import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const BookingTypesFilter = ({
    bookingTypes = [],
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='bookingTypes'
        options={bookingTypes}
        placeholder='Type'
        search
        setValue={restoreFilterValues(filters, 'bookingTypes')}
    />
);

BookingTypesFilter.propTypes = {
    bookingTypes: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
